import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

export type MetricCardArgs = {
  label: string;
  value: string;
  infoLabel?: string;
};

export default function EmailMetrics({ label, value, infoLabel }: MetricCardArgs) {
  return (
    <div className="email-metric-card" key={label}>
      <FontAwesomeIcon
        className="email-metric-card__info"
        icon={faCircleInfo}
        title={infoLabel ?? `${label} info`}
      />
      <span className="email-metric-card__value">{value}</span>
      <span className="email-metric-card__label">{label}</span>
    </div>
  );
}
